import Events from "@wwdev/bootstrap/Events";

class Select2Component {
	constructor() {
		this.fixFocusOnSearchField();
		Events.on('wwdev::select2::init', () =>{
			jQuery('.select2').each( (it, el) => {
				this.initComponent(el);
			});
		});
		// Events.extend('wwdev::ajax::success','wwdev::select2::init');
		var container = document.documentElement || document.body ;

		var config = {
			attributes: true,
			childList: true,
			characterData: true,
			subtree: true
		};

		Events.trigger('wwdev::select2::init');
	}

	fixFocusOnSearchField() {
		jQuery(document).on('select2:open', () => {
			document.querySelector('.select2-search__field').focus();
		});
	}
	initComponent(HtmlElement) {
		var config = $(HtmlElement).data('config');
		$(HtmlElement).select2(config);
	}
}

export default new Select2Component;